import { humanizePredictionLabel } from '@/utils/marketPredictionCopy';
import type { MarketAnalysisTheme } from '@/services/api';

type Props = {
  title: string;
  themes: MarketAnalysisTheme[];
  maxItems?: number;
  className?: string;
};

export function MarketThemeCards({ title, themes, maxItems = 4, className = '' }: Props) {
  const visible = themes
    .filter((theme) => theme.significance?.toLowerCase() !== 'low')
    .slice(0, maxItems);

  if (visible.length === 0) return null;

  return (
    <div className={className}>
      <h4 className="text-lg text-gray-900 mb-5">{title}</h4>
      <div className="space-y-4">
        {visible.map((theme) => (
          <div key={theme.rank ?? theme.theme} className="rounded-2xl border border-gray-100 p-5">
            <div className="flex flex-wrap items-center gap-2 mb-2">
              <p className="font-medium text-gray-900">{theme.theme}</p>
              {theme.direction ? (
                <span className="rounded-lg bg-gray-100 px-2.5 py-0.5 text-xs capitalize text-gray-600">
                  {theme.direction}
                </span>
              ) : null}
              {theme.significance ? (
                <span className="rounded-lg bg-gray-100 px-2.5 py-0.5 text-xs capitalize text-gray-600">
                  {humanizePredictionLabel(theme.significance)}
                </span>
              ) : null}
            </div>
            {theme.mechanism ? (
              <p className="text-sm text-gray-700 leading-relaxed mb-2">{theme.mechanism}</p>
            ) : null}
            {theme.market_impact ? (
              <p className="text-sm text-gray-500 leading-relaxed">{theme.market_impact}</p>
            ) : null}
          </div>
        ))}
      </div>
    </div>
  );
}
